import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { HeartHandshake, X } from "lucide-react";

// Warm first-session banner for referred signups ("Referred by Alex — welcome
// to CivicHearth"). GET is a pure peek; we ack only after the banner has been
// genuinely visible for a moment (or on dismiss) — login redirects briefly
// mount/unmount pages, and a flash-mount must not consume the one-shot state.
export const ReferralWelcomeBanner = () => {
  const [info, setInfo] = useState(null);
  const ackedRef = useRef(false);

  useEffect(() => {
    api.referrerWelcome().then(setInfo).catch(() => {});
  }, []);

  const ack = () => {
    if (ackedRef.current) return;
    ackedRef.current = true;
    api.ackReferrerWelcome().catch(() => {});
  };

  // seen for 1.5s → it counts as shown; a flash-mount cancels the timer
  useEffect(() => {
    if (!info?.show) return;
    const t = setTimeout(ack, 1500);
    return () => clearTimeout(t);
  }, [info?.show]);

  if (!info?.show) return null;
  return (
    <div
      data-testid="referral-welcome-banner"
      className="mb-6 flex items-center gap-3 rounded-2xl border border-terracotta/25 bg-terracotta/5 px-5 py-3.5 text-sm text-neutral-700 animate-fade-up"
    >
      <HeartHandshake className="w-5 h-5 text-terracotta shrink-0" />
      <span className="flex-1">
        Referred by <b className="text-forest">{info.referrer_first_name}</b> — welcome to CivicHearth.
      </span>
      <button
        type="button"
        data-testid="referral-welcome-dismiss"
        aria-label="Dismiss welcome banner"
        onClick={() => { ack(); setInfo(null); }}
        className="text-neutral-400 hover:text-forest transition-colors shrink-0"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
